import React from 'react';
import { Box } from '@mui/material';
import DynamicDatePicker from '../../../../common/DynamicDatePicker';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

interface DateFieldRendererProps {
  value?: string;
  addToActionItems?: boolean;
  onChange: (value: string | null, addToActionItems: boolean) => void;
  fieldName: string;
  label?: string;
  /** Marks the field as required (visual only, e.g. asterisk in label) without blocking save. */
  required?: boolean;
  showBookmark?: boolean;
}

export const DateFieldRenderer: React.FC<DateFieldRendererProps> = ({
  value,
  addToActionItems = false,
  onChange,
  fieldName,
  label,
  required = false,
  showBookmark = true,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ flexGrow: 1 }}>
        <DynamicDatePicker
          fieldName={fieldName}
          label={label}
          required={required}
          value={value}
          onChange={(_, newValue) => onChange(newValue, addToActionItems)}
        />
      </Box>
      {showBookmark ? (
        <Box sx={{ cursor: 'pointer', flexShrink: 0 }} onClick={() => onChange(value || null, !addToActionItems)}>
          {addToActionItems ? <BookmarkIcon sx={{ color: 'primary.main' }} /> : <BookmarkBorderIcon sx={{ color: 'action.disabled' }} />}
        </Box>
      ) : (
        <Box sx={{ width: 24, flexShrink: 0 }} />
      )}
    </Box>
  );
};
